import { FC, useEffect, useState } from 'react';

import { ModalUI } from '../Modal';
import { GlobalPrivacyPolicyProps } from './GlobalPrivacyPolicy.types';
import { StyledSection } from './GlobalPrivacyPolicy.styles';

import { getLegalModalContent } from '../../utils';

export const GlobalPrivacyPolicy: FC<GlobalPrivacyPolicyProps> = ({
  privacyPolicyText,
  privacyPolicyPrimaryCtaText,
  privacyPolicyTarget,
  privacyPolicyPrimaryCtaLink,
}: GlobalPrivacyPolicyProps) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [cssLoaded, setCss] = useState<NodeListOf<Element>>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [legalModalContent, setLegalModalContent] = useState<string>('');
  const privacyStatementId = 'privacy-statement-modal';

  const closeModal = () => {
    setOpenModal(false);
    const linksToRemove = document.querySelectorAll('[data-remove="true"]');
    !cssLoaded?.length && setCss(linksToRemove);
    linksToRemove.forEach(item => item.remove());
  };

  const loadModal = async () => {
    if (openModal) {
      setIsLoading(true);
      try {
        const content = await getLegalModalContent(privacyPolicyPrimaryCtaLink);
        setLegalModalContent(content);
      } catch (error) {
        console.error('Error loading modal content:', error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const element = (
    <div id={privacyStatementId}>
      {isLoading ? (
        <div className="loading">Loading...</div>
      ) : (
        <div dangerouslySetInnerHTML={{ __html: legalModalContent as string }} />
      )}
    </div>
  );

  useEffect(() => {
    loadModal();
  }, [openModal]);

  const privacyPolicyTextArr = privacyPolicyText?.includes('{link}')
    ? privacyPolicyText?.split('{link}')
    : [privacyPolicyText];

  return privacyPolicyTextArr.length > 0 && privacyPolicyText ? (
    <StyledSection
      data-component-name="m-book-GlobalPrivacyPolicy"
      data-testid="book-GlobalPrivacyPolicy"
      className="standard"
    >
      <p>
        {privacyPolicyTextArr?.[0]}
        <a
          href="#"
          id="global-policy-modal"
          onClick={e => {
            e.preventDefault();
            setOpenModal(true);
          }}
          target={privacyPolicyTarget}
        >
          {privacyPolicyPrimaryCtaText}
        </a>
        {(privacyPolicyTextArr.length > 1 && privacyPolicyTextArr?.slice(1).join(' ')) || ''}
      </p>
      <ModalUI
        open={openModal}
        onClose={closeModal}
        keepMounted={false}
        children={element}
        customCss="privacy-statement-modal legalConsent"
        ariaDescribedby="global-privacy-policy"
      />
    </StyledSection>
  ) : null;
};
